module.exports = __webpack_public_path__ + "static/media/sokol.46f8323d.svg";